import React from 'react'
import styled from 'styled-components'
import ShortlistIcon from 'components/icons/DriveTableIcon/Shortlist'
import RejectIcon from 'components/icons/DriveTableIcon/Reject'

const DriveStatus = ({ status ,amount }) => {
  const StyledContainar = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
    // width: 6.5em;
  `
  const StyledIcon = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;
  `
  let colorType
  let tagMessage
  let icon
  if (status == 'INVITED') {
    tagMessage = 'Invited'
  } else if (status === 1) {
    tagMessage = 'Paid'
    icon = <ShortlistIcon />
  } else if (status === 0 && amount <= 0) {
    tagMessage = 'Registered'

  } else if (status === 0 && amount > 0) {
    tagMessage = 'Unpaid'
    icon = <RejectIcon />

  }  else {
    tagMessage = 'Not Registered'
  }
  return (
    <StyledContainar
      style={{
        color: colorType,
        display: 'flex',
      }}
    >
      {icon && <StyledIcon>{icon}</StyledIcon>}
      <div style={{ fontSize: 'smaller', fontWeight: '500' }}>{tagMessage}</div>
    </StyledContainar>
  )
}

export default DriveStatus
